/* Product page: choose metal, size and chain, see the price change, add to bag without leaving the page. */
(function(){
  function money(cents){
    var d = cents / 100;
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function setCount(n){
    [].forEach.call(document.querySelectorAll('[data-bag-count]'), function(el){ el.textContent = n; });
  }

  var info = document.querySelector('[data-product-info]');
  var jsonEl = document.querySelector('[data-product-json]');
  if (!info || !jsonEl) return;
  var product = JSON.parse(jsonEl.textContent);
  var form = info.querySelector('form.pd-form');
  if (!form) return;
  form.noValidate = true;
  var idInput = form.querySelector('[data-variant-id]');
  var priceEl = info.querySelector('[data-price]');
  var startPrice = priceEl ? priceEl.innerHTML : '';
  var optEls = [].slice.call(form.querySelectorAll('[data-option]'));
  var add = form.querySelector('[data-add]');
  var view = form.querySelector('[data-view]');
  var chainEl = info.querySelector('[data-chain]');
  var sizeEl = form.querySelector('[data-size]');
  var metalIndex = -1;
  optEls.forEach(function(el){ if ((el.dataset.name || '') === 'metal') metalIndex = +el.dataset.option; });
  if (metalIndex < 0) product.options.forEach(function(o, i){ var n = (o.name || o).toString().toLowerCase(); if (n === 'metal') metalIndex = i; });

  function chosen(){
    var c = [];
    optEls.forEach(function(el){ c[+el.dataset.option] = el.value; });
    return c;
  }
  function matches(v, c){
    for (var i = 0; i < c.length; i++){ if (c[i] && v.options[i] !== c[i]) return false; }
    return true;
  }
  function update(){
    var c = chosen();
    var list = product.variants.filter(function(v){ return matches(v, c); });
    var all = c.length === product.options.length && c.every(function(x){ return !!x; });
    var exact = all ? list[0] : null;
    if (idInput) idInput.value = exact ? exact.id : (product.variants.length === 1 ? product.variants[0].id : '');
    if (priceEl){
      if (exact){ priceEl.textContent = money(exact.price) + (exact.available ? '' : ' · Sold'); }
      else if (list.length && c.some(function(x){ return !!x; })){
        var lo = Math.min.apply(null, list.map(function(v){ return v.price; })), hi = Math.max.apply(null, list.map(function(v){ return v.price; }));
        priceEl.textContent = (hi > lo ? 'From ' : '') + money(lo);
      } else { priceEl.innerHTML = startPrice; }
    }
    if (add){
      var sold = exact && !exact.available;
      add.disabled = !!sold || !product.available;
      add.textContent = sold || !product.available ? 'Sold' : 'Add to bag';
    }
    if (chainEl && metalIndex > -1){
      var m = c[metalIndex];
      chainEl.innerHTML = !m ? '<b>Chain:</b> ' + chainEl.dataset.silver + ' in silver, ' + chainEl.dataset.gold.toLowerCase() + ' in gold.'
        : '<b>Chain:</b> ' + (/silver/i.test(m) ? chainEl.dataset.silver : chainEl.dataset.gold) + '.';
    }
    var u = new URL(location.href);
    if (exact){ u.searchParams.set('variant', exact.id); history.replaceState(null, '', u); }
  }
  optEls.forEach(function(el){ if (el.tagName === 'SELECT') el.addEventListener('change', function(){ hideErr(el.dataset.option); update(); }); });
  if (sizeEl) sizeEl.addEventListener('change', function(){ hideErr('size'); });

  /* preselect from a ?variant= link */
  var pre = new URL(location.href).searchParams.get('variant');
  if (pre){
    var pv = product.variants.filter(function(v){ return String(v.id) === pre; })[0];
    if (pv) optEls.forEach(function(el){ if (el.tagName === 'SELECT') el.value = pv.options[+el.dataset.option]; });
  }
  update();

  function err(key){ return form.querySelector('[data-err="' + key + '"]'); }
  function hideErr(key){ var e = err(key); if (e) e.hidden = true; }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var first = null;
    optEls.forEach(function(el){
      if (el.tagName !== 'SELECT') return;
      var bad = !el.value, m = err(el.dataset.option);
      if (m) m.hidden = !bad;
      if (bad && !first) first = el;
    });
    if (sizeEl){ var sb = !sizeEl.value, sm = err('size'); if (sm) sm.hidden = !sb; if (sb && !first) first = sizeEl; }
    if (first){ first.focus(); return; }
    update();
    if (!idInput.value){ return; }
    var cartErr = err('cart'); if (cartErr) cartErr.hidden = true;
    add.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }).then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        add.disabled = false;
        if (!res.ok){
          if (cartErr){ cartErr.textContent = res.j.description || res.j.message || 'Sorry, this piece could not be added.'; cartErr.hidden = false; }
          return;
        }
        add.textContent = 'Added to bag';
        if (view) view.hidden = false;
        setTimeout(function(){ add.textContent = 'Add to bag'; }, 1800);
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); }).then(function(cart){ setCount(cart.item_count); });
      })
      .catch(function(){ add.disabled = false; form.submit(); });
  });
})();
